"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.number.constructor");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OperationRecord',
  props: {
    sendId: {
      type: [Number, String],
      default: null
    },
    sendNumber: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      recordList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  watch: {
    sendId: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.currentPage = 1;
          this.loadData();
        }
      }
    },
    sendNumber: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.currentPage = 1;
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      if (!this.sendId && !this.sendNumber) return;
      this.loading = true;
      var params = {
        page: this.currentPage - 1,
        size: this.pageSize
      };

      if (this.sendId) {
        params.sendId = this.sendId;
      }

      if (this.sendNumber) {
        params.sendNumber = this.sendNumber;
      }

      (0, _send.getSendTaskLog)(params).then(function (response) {
        if (response.code === 200) {
          _this.recordList = response.data.content || [];
          _this.total = response.data.totalElements || 0;
        } else {
          _this.$message.error(response.msg || '加载操作记录失败');
        }
      }).catch(function () {
        _this.$message.error('网络错误');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    getActionType: function getActionType(action) {
      var map = {
        '创建': '',
        '提交': 'primary',
        '审核': 'success',
        '取消': 'danger',
        '删除': 'danger',
        '编辑': 'warning',
        '添加任务': 'primary',
        '取消任务': 'danger',
        '添加费用': 'primary',
        '审核费用': 'success',
        '编辑费用': 'warning'
      };
      return map[action] || 'info';
    },
    getPhotoList: function getPhotoList(photo) {
      if (!photo) return [];
      return photo.split(',').map(function (url) {
        return url.trim();
      }).filter(function (url) {
        return url;
      });
    },
    getTimelineColor: function getTimelineColor(action) {
      var map = {
        '创建': '#409EFF',
        '提交': '#409EFF',
        '审核': '#67C23A',
        '取消': '#F56C6C',
        '删除': '#F56C6C',
        '编辑': '#E6A23C',
        '添加任务': '#409EFF',
        '取消任务': '#F56C6C',
        '添加费用': '#409EFF',
        '审核费用': '#67C23A'
      };
      return map[action] || '#909399';
    }
  }
};
exports.default = _default;